{
  "statusLabels": {
    "active": "Đang hoạt động",
    "suspended": "Tạm khóa",
    "closed": "Đã đóng"
  },
  "tierLabels": {
    "titanium": "Titanium",
    "platinum": "Platinum",
    "diamond": "Diamond",
    "enterprise": "Enterprise",
    "e2": "E2",
    "e3": "E3"
  },
  "list": {
    "header": {
      "title": "Merchant",
      "description": "Xem, lọc và thao tác hàng loạt trên tài khoản merchant. Chỉ thêm qua lời mời — không có nút Tạo mới. Merchant bị tạm khóa vẫn bấm vào được để xem các mục chỉ đọc."
    },
    "toggle": {
      "showClosed": "Hiện merchant đã đóng"
    },
    "legend": {
      "aria": "Chú thích màu dòng",
      "label": "Chú thích dòng:",
      "suspended": "Tạm khóa",
      "new": "Mới (< 7 ngày)"
    },
    "columns": {
      "name": "Tên",
      "email": "Email",
      "status": "Trạng thái",
      "tier": "Hạng",
      "wallet": "Ví",
      "creditTotal": "Tổng credit",
      "creditUsed": "Credit đã dùng",
      "creditExpiry": "Credit hết hạn",
      "orders": "Đơn hàng",
      "gmv": "GMV",
      "lastLogin": "Đăng nhập gần nhất",
      "stores": "Cửa hàng",
      "autoPay": "Tự động trả",
      "autoRecharge": "Tự động nạp",
      "transferBlock": "Chặn TG",
      "cardPayment": "Thanh toán thẻ",
      "created": "Ngày tạo",
      "amCs": "AM & CS"
    },
    "filters": {
      "search": {
        "label": "Tìm kiếm",
        "placeholder": "Tên, email, doanh nghiệp…"
      },
      "status": {
        "label": "Trạng thái"
      },
      "tier": {
        "label": "Hạng"
      },
      "transferBlock": {
        "label": "Chặn chuyển nhóm",
        "blocked": "Đã chặn",
        "notBlocked": "Chưa chặn"
      },
      "cardPayment": {
        "label": "Thanh toán thẻ",
        "enabled": "Đã bật",
        "disabled": "Chưa bật"
      },
      "dateRange": "Khoảng ngày"
    },
    "bulk": {
      "suspend": "Tạm khóa",
      "activate": "Kích hoạt",
      "setTier": "Đặt hạng",
      "setCredit": "Đặt credit",
      "export": "Xuất CSV"
    },
    "actions": {
      "openAria": "Mở merchant {{name}}",
      "openTitle": "Mở chi tiết merchant"
    },
    "amCs": {
      "am": "AM",
      "cs": "CS",
      "assign": "Gán",
      "reassignTitle": "Gán lại AM & CS"
    },
    "boolean": {
      "on": "Bật",
      "off": "Tắt"
    },
    "transferBlocked": {
      "label": "Chặn TG",
      "title": "Bị chặn khỏi nhóm chuyển tiền"
    },
    "empty": "Không có merchant nào khớp bộ lọc.",
    "toast": {
      "noSelection": {
        "title": "Chưa chọn merchant",
        "description": "Chọn ít nhất một merchant để chạy thao tác hàng loạt này."
      },
      "selectFirst": {
        "title": "Chưa chọn merchant",
        "suspend": "Chọn ít nhất một merchant để chạy bulk suspend.",
        "activate": "Chọn ít nhất một merchant để chạy bulk activate.",
        "setTier": "Chọn ít nhất một merchant để đổi tier.",
        "setCredit": "Chọn ít nhất một merchant để set credit."
      },
      "approvalRequired": {
        "title": "Cần phê duyệt kép",
        "description_one": "Lô đã tạm giữ. Mã yêu cầu {{requestId}}; {{count}} merchant vượt ngưỡng {{threshold}}.",
        "description_other": "Lô đã tạm giữ. Mã yêu cầu {{requestId}}; {{count}} merchant vượt ngưỡng {{threshold}}."
      },
      "exportQueued": {
        "title": "Đã đưa vào hàng đợi xuất",
        "description_one": "Tác vụ xuất {{jobId}} đã vào hàng đợi cho {{count}} merchant ({{format}}).",
        "description_other": "Tác vụ xuất {{jobId}} đã vào hàng đợi cho {{count}} merchant ({{format}})."
      },
      "applied": {
        "title": "Đã áp dụng thao tác hàng loạt",
        "description_one": "Đã cập nhật {{count}} merchant.",
        "description_other": "Đã cập nhật {{count}} merchant."
      },
      "failed": {
        "title": "Thao tác hàng loạt thất bại",
        "networkError": "Lỗi mạng — kiểm tra kết nối"
      }
    },
    "bulkModals": {
      "cancel": "Hủy",
      "pending": "Đang xử lý…",
      "suspend": {
        "heading_one": "Tạm khóa hàng loạt {{count}} merchant",
        "heading_other": "Tạm khóa hàng loạt {{count}} merchant",
        "body_one": "Tạm khóa {{count}} merchant đã chọn. Ngừng đăng nhập + ngừng đặt đơn mới; có thể reactivate sau.",
        "body_other": "Tạm khóa {{count}} merchant đã chọn. Ngừng đăng nhập + ngừng đặt đơn mới; có thể reactivate sau.",
        "reasonLabel": "Lý do",
        "noteLabel": "Ghi chú (note) — tối đa 2000 ký tự",
        "noteLabelRequired": "Ghi chú (note) * — tối đa 2000 ký tự",
        "notePlaceholderRequired": "Bắt buộc khi chọn \"Lý do khác\" (≥10 ký tự).",
        "notePlaceholderOptional": "Tùy chọn.",
        "confirm": "Tạm khóa",
        "reasons": {
          "tosViolation": "Vi phạm điều khoản (TOS)",
          "fraudSuspected": "Nghi ngờ gian lận",
          "chargeback": "Chargeback / dispute kéo dài",
          "merchantRequest": "Theo yêu cầu của merchant",
          "complianceReview": "Đang rà soát tuân thủ",
          "other": "Lý do khác (ghi rõ ở note)"
        }
      },
      "activate": {
        "heading_one": "Kích hoạt hàng loạt {{count}} merchant",
        "heading_other": "Kích hoạt hàng loạt {{count}} merchant",
        "body_one": "Gỡ suspend cho {{count}} merchant đã chọn. Merchant sẽ đăng nhập và đặt đơn được trở lại ngay sau khi xác nhận.",
        "body_other": "Gỡ suspend cho {{count}} merchant đã chọn. Merchant sẽ đăng nhập và đặt đơn được trở lại ngay sau khi xác nhận.",
        "noteLabel": "Ghi chú (note) — tối đa 2000 ký tự, tùy chọn",
        "confirm": "Kích hoạt"
      },
      "setTier": {
        "heading_one": "Đổi tier cho {{count}} merchant",
        "heading_other": "Đổi tier cho {{count}} merchant",
        "body_one": "Tier mới áp dụng cho tất cả {{count}} merchant đã chọn. Tier ảnh hưởng credit ladder + withdraw permission.",
        "body_other": "Tier mới áp dụng cho tất cả {{count}} merchant đã chọn. Tier ảnh hưởng credit ladder + withdraw permission.",
        "tierLabel": "Tier mới",
        "confirm": "Áp dụng tier"
      },
      "setCredit": {
        "heading_one": "Đặt credit total cho {{count}} merchant",
        "heading_other": "Đặt credit total cho {{count}} merchant",
        "body_one": "Áp dụng credit_total mới cho tất cả {{count}} merchant đã chọn. Nhập số tiền theo USD — hệ thống tự chuyển sang cents.",
        "body_other": "Áp dụng credit_total mới cho tất cả {{count}} merchant đã chọn. Nhập số tiền theo USD — hệ thống tự chuyển sang cents.",
        "amountLabel": "Credit total (USD, ≥0)",
        "invalid": "Nhập số không âm.",
        "centsHint": "= {{cents}} cents",
        "confirm": "Áp dụng credit"
      }
    }
  },
  "tabsNav": {
    "ariaLabel": "Tab merchant",
    "all": {
      "label": "Tất cả",
      "description": "Tất cả merchant trừ đã đóng."
    },
    "active": {
      "label": "Đang hoạt động",
      "description": "Merchant có chủ đang hoạt động."
    },
    "suspended": {
      "label": "Tạm khóa",
      "description": "Merchant có chủ bị tạm khóa. Các mục chỉ đọc vẫn hoạt động."
    },
    "new": {
      "label": "Mới (<7n)",
      "description": "Merchant tạo trong 7 ngày gần nhất (màu dòng)."
    },
    "closed": {
      "label": "Đã đóng",
      "description": "Merchant đã xóa mềm. Ẩn mặc định — bật toggle ở trang danh sách."
    }
  },
  "detail": {
    "back": "Quay lại Merchants",
    "missingId": "Thiếu mã merchant trong URL.",
    "loadingTab": "Đang tải tab",
    "sectionsLabel": "Các mục chi tiết merchant",
    "error": "Không tải được chi tiết merchant",
    "unknownError": "Lỗi không xác định",
    "tabs": {
      "overview": "Tổng quan",
      "wallet": "Ví",
      "credit": "Credit",
      "orders": "Đơn",
      "products": "Sản phẩm",
      "team-stores": "Đội - Cửa hàng"
    },
    "charCounter": {
      "needChars_one": "Cần thêm {{count}} ký tự",
      "needChars_other": "Cần thêm {{count}} ký tự",
      "minChars_one": "Tối thiểu {{count}} ký tự",
      "minChars_other": "Tối thiểu {{count}} ký tự",
      "eligible": "Đủ điều kiện"
    },
    "reactivate": {
      "title": "Kích hoạt lại merchant",
      "bodyPrefix": "Gỡ đình chỉ cho ",
      "bodySuffix": ". Merchant được khôi phục toàn quyền truy cập ngay lập tức; nhật ký kiểm toán ghi lại người thực hiện và lý do.",
      "reasonLabel": "Lý do (không bắt buộc)",
      "cancel": "Hủy",
      "confirm": "Kích hoạt lại",
      "pending": "Đang kích hoạt lại…"
    },
    "unblockTransfer": {
      "title": "Gỡ chặn Transfer Group (nhóm chuyển)",
      "bodyPrefix": "Bỏ flag chặn cho ",
      "bodySuffix": ". Merchant sẽ quay lại danh sách người nhận của các Transfer Group ngay sau khi xác nhận. Audit log ghi lại người gỡ chặn và lý do.",
      "existingReasonLabel": "Lý do chặn ban đầu:",
      "reasonLabel": "Lý do gỡ chặn",
      "reasonRange": "(10..{{max}} ký tự)",
      "placeholder": "Ví dụ: Compliance đã rà soát xong, merchant đủ điều kiện hoạt động lại.",
      "cancel": "Hủy",
      "confirm": "Gỡ chặn",
      "pending": "Đang gỡ chặn…"
    },
    "forceProduct": {
      "titleDelete": "Xóa cứng (force delete) sản phẩm",
      "titleUnpublish": "Gỡ publish (force unpublish) sản phẩm",
      "bodyPrefix": "Sản phẩm ",
      "bodyMiddle": " của merchant ",
      "bodyEnd": ".",
      "noteDelete": "Force delete đánh dấu DELETED_BY_ADMIN — không thể khôi phục.",
      "noteUnpublish": "Force unpublish ẩn sản phẩm khỏi storefront, có thể publish lại sau.",
      "codeLabel": "Mã lý do (code)",
      "codes": {
        "POLICY_VIOLATION": "Vi phạm chính sách",
        "COPYRIGHT": "Vi phạm bản quyền",
        "QUALITY": "Vấn đề chất lượng",
        "OTHER": "Lý do khác"
      },
      "reasonLabel": "Lý do chi tiết",
      "reasonRange": "(10..{{max}} ký tự)",
      "reasonPlaceholderDelete": "Mô tả chi tiết lý do xóa cứng sản phẩm này…",
      "reasonPlaceholderUnpublish": "Mô tả chi tiết lý do gỡ publish sản phẩm này…",
      "notifyEmail": "Gửi email cho merchant",
      "notifyInApp": "Notification trong app",
      "confirmNameLabel": "Nhập tên merchant để xác nhận xóa:",
      "nameMismatch": "Tên merchant chưa khớp.",
      "cancel": "Hủy",
      "pending": "Đang xử lý…",
      "confirmDelete": "Xóa cứng",
      "confirmUnpublish": "Gỡ publish"
    },
    "pricingProfile": {
      "title": "Hồ sơ giá",
      "helper": "Chỉ là nhãn thông tin — không bao giờ thay đổi công thức tính giá. Dùng cho báo cáo và mốc chuyển đổi 2027.",
      "profiles": {
        "legacy_v2": "Legacy V2",
        "standard": "Standard V3"
      },
      "editLabel": "Đổi hồ sơ",
      "selectLabel": "Hồ sơ giá",
      "reasonLabel": "Lý do (bắt buộc)",
      "reasonPlaceholder": "Vì sao đổi nhãn này?",
      "reasonRequired": "Cần nhập lý do.",
      "save": "Lưu hồ sơ",
      "saving": "Đang lưu…",
      "cancel": "Huỷ",
      "auditNote": "Mọi thay đổi đều được ghi vào nhật ký kiểm toán.",
      "noRecalcNote": "Đơn đã xác nhận giữ nguyên giá đã chốt — nhãn này không tính lại chúng.",
      "savedToast": "Đã cập nhật hồ sơ giá.",
      "errorToast": "Không thể cập nhật hồ sơ giá."
    }
  },
  "stickyHeader": {
    "actions": {
      "editProfile": "Sửa hồ sơ",
      "reactivate": "Kích hoạt lại",
      "suspend": "Đình chỉ",
      "blockTransfer": "Chặn khỏi Transfer Group",
      "unblockTransfer": "Gỡ chặn khỏi Transfer Group",
      "blockTransferTitle": "Cách ly khỏi các transfer group theo chu kỳ chi phí",
      "unblockTransferTitle": "Gỡ chặn Transfer Group (POST /:id/transfer-unblock)",
      "impersonate": "Đăng nhập hộ (impersonate)"
    }
  },
  "overview": {
    "aria": {
      "panel": "Tổng quan merchant"
    },
    "profile": {
      "heading": "Hồ sơ",
      "name": "Tên",
      "email": "Email",
      "phone": "Số điện thoại",
      "businessName": "Tên doanh nghiệp",
      "taxId": "Mã số thuế",
      "businessAddress": "Địa chỉ doanh nghiệp"
    },
    "kpis": {
      "totalOrders": "Tổng đơn hàng",
      "totalRevenue": "Tổng doanh thu",
      "products": "Sản phẩm",
      "connectedStores": "Cửa hàng đã kết nối"
    },
    "wallet": {
      "balance": "Số dư ví",
      "creditTotal": "Tổng tín dụng",
      "pendingTopups": "Nạp tiền chờ duyệt",
      "withdraw": "Rút tiền",
      "enabled": "Đã bật",
      "disabled": "Đã tắt",
      "withdrawHintEnterprise": "Hạng Enterprise",
      "withdrawHintLocked": "Đã khoá: không phải hạng Enterprise",
      "withdrawHintEnabled": "Đã bật — quản lý ở tab Wallet",
      "withdrawHintDisabled": "Mặc định tắt — bật cho từng merchant ở tab Wallet"
    },
    "notes": {
      "heading": "Ghi chú nội bộ",
      "adminOnly": "(chỉ admin)"
    },
    "activity": {
      "heading": "Hoạt động gần đây",
      "subtitle": "10 sự kiện gần nhất từ audit log",
      "errorFallback": "Không tải được activity feed",
      "empty": "Chưa có sự kiện nào được ghi nhận cho merchant này.",
      "system": "Hệ thống",
      "dot": {
        "securityAudit": "Kiểm toán bảo mật",
        "adminAction": "Hành động của admin",
        "ownerAction": "Hành động của chủ merchant"
      },
      "relative": {
        "justNow": "vừa xong",
        "minutesAgo_one": "{{count}} phút trước",
        "minutesAgo_other": "{{count}} phút trước",
        "hoursAgo_one": "{{count}} giờ trước",
        "hoursAgo_other": "{{count}} giờ trước",
        "daysAgo_one": "{{count}} ngày trước",
        "daysAgo_other": "{{count}} ngày trước"
      }
    }
  },
  "wallet": {
    "aria": {
      "panel": "Ví & thanh toán"
    },
    "errorFallback": "Không tải được chi tiết ví",
    "cards": {
      "balance": "Số dư ví",
      "creditRemaining": "Tín dụng còn lại",
      "pendingTopups": "Nạp tiền chờ duyệt",
      "expires": "Hết hạn {{date}}",
      "noExpiry": "Không đặt hạn",
      "pendingRequests_one": "{{count}} yêu cầu đang chờ",
      "pendingRequests_other": "{{count}} yêu cầu đang chờ"
    },
    "withdraw": {
      "heading": "Quyền rút tiền",
      "enterpriseOnly": "(chỉ Enterprise)",
      "enabled": "Đã bật",
      "disabled": "Đã tắt",
      "dailyLimit": "Hạn mức ngày:",
      "toggleLabel": "Cho phép merchant này rút tiền",
      "offByDefaultHint": "Mặc định tắt. Merchant chỉ thấy nút Rút tiền khi được bật.",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "saved": "Đã cập nhật quyền rút tiền",
      "saveError": "Cập nhật quyền rút tiền thất bại",
      "loadError": "Không đọc được quyền rút tiền hiện tại. Đã khoá chỉnh sửa để lần đọc hỏng không bị lưu đè thành thay đổi."
    },
    "cardPayment": {
      "heading": "Thanh toán bằng thẻ",
      "toggleLabel": "Cho phép merchant này thanh toán bằng thẻ đã lưu",
      "offByDefaultHint": "Mặc định tắt. Khi bật, merchant trả đơn và hoá đơn thẳng bằng thẻ đã lưu thay vì trừ ví. Merchant thanh toán theo hoá đơn chỉ trả được hoá đơn, không trả từng đơn.",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "saved": "Đã cập nhật quyền thanh toán bằng thẻ",
      "saveError": "Cập nhật quyền thanh toán bằng thẻ thất bại",
      "loadError": "Không đọc được quyền thanh toán bằng thẻ hiện tại. Đã khoá chỉnh sửa để lần đọc hỏng không bị lưu đè thành thay đổi.",
      "maxPerOrder": "Trần mỗi lần (USD)",
      "maxPerDay": "Trần mỗi ngày (USD)",
      "noLimitHint": "Để trống nghĩa là không giới hạn. Khoản đã trừ thẻ không hoàn ngược về thẻ từ đây được, nên đặt trần là cách chặn thiệt hại khi sai.",
      "noLimitConfirm": "Tôi xác nhận để trống nghĩa là không giới hạn",
      "noLimitRequired": "Để trống hạn mức nghĩa là chi tiêu thẻ không giới hạn — tích ô xác nhận, hoặc nhập số tiền."
    },
    "creditPolicy": {
      "heading": "Chính sách tín dụng",
      "autoPay": "Tự động thanh toán",
      "autoRecharge": "Tự động nạp",
      "totalCredit": "Tổng tín dụng",
      "creditUsed": "Tín dụng đã dùng",
      "on": "Bật",
      "off": "Tắt"
    },
    "billingModes": {
      "PREPAID": {
        "label": "Prepaid (nạp ví trước)",
        "hint": "Merchant nạp số dư trước; không phát hành hóa đơn."
      },
      "CREDIT": {
        "label": "Credit (auto recharge)",
        "hint": "Ví tự động nạp từ gateway đã lưu; recharge fail → suspend."
      },
      "INVOICE": {
        "label": "Invoice (NET terms)",
        "hint": "Phát hành hóa đơn định kỳ; NET-N ngày để thanh toán sau khi issue."
      }
    },
    "switcher": {
      "heading": "Chế độ thanh toán (billing mode)",
      "description": "Chế độ chi phối cách wallet/credit/invoice vận hành. Đổi nhanh ở đây — cấu hình chi tiết & lịch sử hóa đơn ở trang đầy đủ.",
      "newMode": "Chế độ mới",
      "reasonLabel": "Lý do (audit, tối thiểu 10 ký tự)",
      "selectTitleAdmin": "Chọn chế độ mới rồi nhập lý do để xác nhận",
      "selectTitleReadonly": "Chỉ admin được đổi mode (accountant chỉ xem)",
      "reasonPlaceholder": "Ví dụ: chuyển sang INVOICE NET-7 theo thỏa thuận hợp đồng.",
      "detailLink": "Mở trang Tài chính & Hóa đơn đầy đủ →",
      "submitting": "Đang đổi…",
      "submit": "Xác nhận đổi mode",
      "submitTitleNotAdmin": "Chỉ admin/superadmin được đổi mode",
      "submitTitleNotDirty": "Chọn chế độ khác chế độ hiện tại trước",
      "submitTitleReasonShort_one": "Nhập thêm {{count}} ký tự lý do",
      "submitTitleReasonShort_other": "Nhập thêm {{count}} ký tự lý do",
      "submitTitleReady": "Xác nhận đổi chế độ thanh toán",
      "successMessage": "Đã đổi sang {{mode}}.",
      "networkError": "Lỗi mạng"
    },
    "permission": {
      "readOnly": "Chỉ xem — bạn không có quyền billing"
    }
  },
  "orders": {
    "aria": {
      "panel": "Đơn hàng của merchant"
    },
    "errorFallback": "Không tải được đơn hàng",
    "columns": {
      "orderNumber": "Mã đơn",
      "status": "Trạng thái",
      "grandTotal": "Tổng cộng",
      "created": "Ngày tạo"
    },
    "empty": "Không có đơn hàng nào cho merchant này.",
    "pager": {
      "pageInfo_one": "Trang {{page}} · {{count}} dòng",
      "pageInfo_other": "Trang {{page}} · {{count}} dòng",
      "prev": "Trước",
      "next": "Sau"
    },
    "statusLabels": {
      "draft": "Nháp",
      "pending_payment": "Chờ thanh toán",
      "pending_emb_payment": "Chờ thanh toán thêu",
      "confirmed": "Đã xác nhận",
      "assigned": "Đã phân công",
      "accepted": "Đã nhận",
      "in_production": "Đang sản xuất",
      "quality_check": "Kiểm tra chất lượng",
      "ready_to_ship": "Sẵn sàng giao",
      "on_hold": "Tạm giữ",
      "pending_reassignment": "Chờ phân công lại",
      "shipped": "Đã giao vận",
      "partially_shipped": "Giao vận một phần",
      "delivered": "Đã giao",
      "returned_partial": "Trả hàng (một phần)",
      "partially_cancelled": "Huỷ một phần",
      "cancelled": "Đã huỷ",
      "attention_required": "Cần chú ý",
      "unknown": "Không rõ"
    }
  },
  "products": {
    "aria": {
      "panel": "Sản phẩm của merchant"
    },
    "errorFallback": "Không tải được sản phẩm",
    "columns": {
      "avatar": "Ảnh đại diện",
      "title": "Tên sản phẩm",
      "status": "Trạng thái",
      "published": "Đã đăng",
      "baseCost": "Giá gốc",
      "created": "Ngày tạo",
      "actions": "Thao tác"
    },
    "empty": "Không có sản phẩm nào cho merchant này.",
    "publishedBadge": "Đã đăng",
    "draftBadge": "Nháp",
    "actions": {
      "forceUnpublish": "Buộc gỡ đăng",
      "forceDelete": "Buộc xoá",
      "handlerUnavailable": "Hành động chưa khả dụng trong context này.",
      "unpublishNoTarget": "Sản phẩm đang ở trạng thái Draft (chưa publish) — không cần gỡ.",
      "unpublishReady": "Ẩn sản phẩm khỏi storefront. Có thể publish lại sau.",
      "deleteReady": "Force delete đánh dấu DELETED_BY_ADMIN — không thể khôi phục.",
      "forceUnpublishAria": "Buộc gỡ đăng — {{reason}}",
      "forceDeleteAria": "Buộc xoá — {{reason}}"
    },
    "pager": {
      "pageInfo_one": "Trang {{page}} · {{count}} dòng",
      "pageInfo_other": "Trang {{page}} · {{count}} dòng",
      "prev": "Trước",
      "next": "Sau"
    },
    "statusLabels": {
      "draft": "Nháp",
      "active": "Hoạt động",
      "inactive": "Ngừng",
      "archived": "Lưu trữ",
      "deleted": "Đã xoá",
      "published": "Đã đăng",
      "unpublished": "Chưa đăng",
      "pending": "Chờ duyệt"
    }
  },
  "teamStores": {
    "aria": {
      "panel": "Team và cửa hàng của merchant"
    },
    "errorFallback": "Không tải được team & cửa hàng",
    "readonlyBanner": "Lưu ý: Phần Team & Stores chỉ xem (view-only) — admin Printway không thêm / sửa / xoá thành viên (, merchant autonomy). Suspend toàn merchant sẽ tự động đóng băng tất cả thành viên team.",
    "team": {
      "heading": "Thành viên team",
      "empty": "Chưa có thành viên nào.",
      "columns": {
        "name": "Tên",
        "email": "Email",
        "role": "Vai trò",
        "status": "Trạng thái",
        "joined": "Tham gia"
      }
    },
    "stores": {
      "heading": "Cửa hàng đã kết nối",
      "empty": "Chưa có cửa hàng kết nối.",
      "openLink": "Mở chi tiết cửa hàng",
      "columns": {
        "store": "Cửa hàng",
        "platform": "Nền tảng",
        "domain": "Tên miền",
        "status": "Trạng thái",
        "connected": "Kết nối",
        "actions": "Thao tác"
      }
    },
    "roleLabels": {
      "owner": "Chủ sở hữu",
      "accountant": "Kế toán",
      "operator": "Vận hành",
      "viewer": "Người xem",
      "member": "Thành viên"
    },
    "teamStatusLabels": {
      "pending": "Chờ duyệt",
      "active": "Hoạt động",
      "suspended": "Tạm ngưng",
      "removed": "Đã xoá",
      "inactive": "Ngừng"
    },
    "storeStatusLabels": {
      "Active": "Hoạt động",
      "Disconnected": "Mất kết nối",
      "Frozen": "Đóng băng",
      "Inactive": "Ngừng"
    },
    "platformLabels": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "woocommerce": "WooCommerce",
      "tiktok": "TikTok",
      "amazon": "Amazon",
      "manual": "Thủ công",
      "unknown": "Không rõ"
    }
  },
  "modals": {
    "common": {
      "cancel": "Hủy",
      "charsNeeded_one": "Cần thêm {{count}} ký tự",
      "charsNeeded_other": "Cần thêm {{count}} ký tự",
      "ready": "Đủ điều kiện",
      "networkError": "Lỗi kết nối — vui lòng kiểm tra mạng",
      "minCharsPlaceholder": "Tối thiểu {{min}} ký tự…",
      "reasonWithMinPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…"
    },
    "blockTransfer": {
      "title": "Chặn merchant khỏi Transfer Group (nhóm chuyển)",
      "description": {
        "withName": "Merchant {{name}} sẽ bị loại khỏi danh sách người nhận của mọi Transfer Group (nhóm chuyển). Hành động này KHÔNG ảnh hưởng đăng nhập, đơn hàng hay ví — chỉ chặn việc merchant được di chuyển vào nhóm chuyển chi phí.",
        "withoutName": "Merchant sẽ bị loại khỏi danh sách người nhận của mọi Transfer Group (nhóm chuyển). KHÔNG ảnh hưởng đăng nhập / đơn hàng / ví."
      },
      "reasonLegend": "Lý do chặn",
      "reasons": {
        "fraud_suspected": {
          "label": "Nghi ngờ gian lận",
          "hint": "Phát hiện dấu hiệu fraud (gian lận) — cần điều tra trước khi cho phép transfer (chuyển nhóm)."
        },
        "abnormal_pattern": {
          "label": "Mô hình giao dịch bất thường",
          "hint": "Pattern (mẫu) khối lượng / tần suất đặt hàng lệch hẳn baseline."
        },
        "compliance_review": {
          "label": "Đang rà soát tuân thủ",
          "hint": "Compliance (tuân thủ) team đang xem hồ sơ — tạm khóa transfer trong thời gian rà soát."
        },
        "merchant_request": {
          "label": "Theo yêu cầu của merchant",
          "hint": "Chính merchant yêu cầu chặn — ví dụ tạm dừng kinh doanh."
        },
        "other": {
          "label": "Lý do khác",
          "hint": "Ghi rõ trong ô note (ghi chú) bên dưới."
        }
      },
      "noteLabel": "Ghi chú (note)",
      "notePlaceholder": {
        "required": "Vì chọn \"Lý do khác\", vui lòng mô tả chi tiết (tối thiểu 10 ký tự)…",
        "optional": "Ghi chú bổ sung (tùy chọn). {{hint}}"
      },
      "confirm": "Chặn khỏi Transfer Group",
      "submitting": "Đang chặn…"
    },
    "forceDeleteProduct": {
      "title": "Xóa cứng sản phẩm (force delete)",
      "description": {
        "withProduct": "Hành động này KHÔNG THỂ hoàn tác. Sản phẩm {{product}} sẽ bị đánh dấu DELETED_BY_ADMIN và biến mất khỏi catalog của merchant {{merchant}}.",
        "withoutProduct": "Hành động này KHÔNG THỂ hoàn tác. Sản phẩm sẽ bị đánh dấu DELETED_BY_ADMIN và biến mất khỏi catalog của merchant {{merchant}}."
      },
      "reasonCodeLabel": "Mã lý do",
      "reasonCodes": {
        "POLICY_VIOLATION": "Vi phạm chính sách (POLICY_VIOLATION)",
        "COPYRIGHT": "Bản quyền (COPYRIGHT)",
        "QUALITY": "Chất lượng (QUALITY)",
        "OTHER": "Khác (OTHER)"
      },
      "detailLabel": "Lý do chi tiết",
      "notifyEmail": "Gửi email cho merchant",
      "notifyInApp": "Gửi thông báo in-app cho merchant",
      "confirmNameLabel": "Để xác nhận, nhập đúng tên merchant {{name}}",
      "nameMismatch": "Tên không khớp.",
      "confirm": "Xóa cứng sản phẩm",
      "submitting": "Đang xóa…"
    },
    "freezeWallet": {
      "title": {
        "freeze": "Đóng băng ví merchant",
        "unfreeze": "Mở băng ví merchant"
      },
      "description": {
        "freezeWithName": "Ví của merchant {{name}} sẽ chuyển sang Suspended. Toàn bộ giao dịch ghi nợ mới sẽ bị từ chối.",
        "freezeWithoutName": "Ví merchant sẽ chuyển sang Suspended. Toàn bộ giao dịch ghi nợ mới sẽ bị từ chối.",
        "unfreezeWithName": "Ví của merchant {{name}} sẽ được mở lại (Active). Ví đang ở trạng thái thu hồi do chargeback sẽ không bị ảnh hưởng.",
        "unfreezeWithoutName": "Ví merchant sẽ chuyển về Active. Ví ở trạng thái chargeback recovery không bị tác động."
      },
      "currencyScope": "Chỉ áp dụng cho ví đồng tiền {{currency}}.",
      "reasonLabel": "Lý do",
      "confirm": {
        "freeze": "Đóng băng ví",
        "unfreeze": "Mở băng ví"
      },
      "submitting": "Đang xử lý…"
    },
    "impersonate": {
      "title": {
        "withLabel": "Đăng nhập với tư cách Merchant — {{name}}",
        "plain": "Đăng nhập với tư cách Merchant"
      },
      "description": "Bạn sẽ đăng nhập với danh nghĩa merchant để hỗ trợ / điều tra. Mọi thao tác được audit log (ghi nhật ký) đầy đủ.",
      "supportDenied": "Tài khoản Support Admin không có quyền impersonate (giả lập đăng nhập). Vui lòng liên hệ Super Admin nếu cần.",
      "warningBanner": {
        "title": "Bạn sẽ đăng nhập với danh nghĩa merchant này. Mọi hành động đều được ghi audit log.",
        "subtitle": "Toàn bộ thao tác trong phiên này sẽ được ghi vào nhật ký kiểm toán (audit log)."
      },
      "modePreview": {
        "title": "Mode (chế độ): read-only + allowlist 3 actions",
        "ordersView": "orders:view — xem đơn hàng",
        "merchantsView": "merchants:view — xem hồ sơ merchant",
        "storesView": "stores:view — xem store",
        "note": "Mọi action ghi (write) khác sẽ bị server từ chối với mã IMPERSONATE_READONLY trong phiên giả lập."
      },
      "cookieInfo": {
        "title": "Cookie sẽ được set trên subdomain (tên miền con):",
        "expiry": "Phiên giả lập (impersonate session) hết hạn sau 30 phút."
      },
      "reasonLabel": "Lý do (audit, ≥ {{min}} ký tự)",
      "confirm": "Impersonate Merchant",
      "submitting": "Đang khởi tạo…"
    },
    "suspend": {
      "title": "Tạm dừng merchant",
      "description": {
        "withName": "Merchant {{name}} sẽ chuyển sang trạng thái Suspended (đang khóa). Toàn bộ ví sẽ bị đóng băng và đơn đang xử lý sẽ bị giữ lại.",
        "withoutName": "Merchant sẽ chuyển sang trạng thái Suspended. Ví bị đóng băng, đơn đang xử lý bị giữ."
      },
      "dualApprovalBanner": "Bulk > 5 merchant — cần phê duyệt kép (dual approval,) trước khi áp dụng cho toàn bộ tập đã chọn.",
      "previewSummary": "{{orders}} đơn đang xử lý sẽ bị tạm dừng, {{stores}} cửa hàng dừng sync, {{wallets}} ví bị khóa.",
      "previewError": "Không tải được dữ liệu xem trước",
      "previewLoading": "Đang tải xem trước…",
      "reasonCodeLabel": "Mã lý do (reason code)",
      "reasonCodes": {
        "FRAUD": "Gian lận (FRAUD)",
        "NON_PAYMENT": "Chậm thanh toán (NON_PAYMENT)",
        "POLICY_VIOLATION": "Vi phạm chính sách (POLICY_VIOLATION)",
        "CHARGEBACK": "Chargeback",
        "KYC_FAILURE": "KYC thất bại (KYC_FAILURE)",
        "SECURITY": "Bảo mật (SECURITY)",
        "VOLUNTARY_REQUEST": "Yêu cầu tự nguyện (VOLUNTARY_REQUEST)",
        "OTHER": "Khác (OTHER)"
      },
      "reasonLabel": "Lý do tạm dừng",
      "notify": "Gửi thông báo (email + in-app) cho merchant",
      "confirm": "Tạm dừng merchant",
      "submitting": "Đang tạm dừng…"
    },
    "setEditCredit": {
      "title": {
        "edit": "Sửa hạn mức tín dụng",
        "new": "Cấp hạn mức tín dụng"
      },
      "description": {
        "withName": "Merchant {{name}}. Toàn bộ thay đổi sẽ được ghi audit.",
        "withoutName": "Toàn bộ thay đổi sẽ được ghi audit."
      },
      "limitLabel": "Hạn mức (USD)",
      "periodLabel": "Chu kỳ (ngày)",
      "remindAtLabel": "Nhắc khi sử dụng tới (USD)",
      "remindAtPlaceholder": "Để trống nếu không nhắc",
      "limitWarning": "Hạn mức tín dụng chỉ được phép tăng, không được giảm.",
      "notify": "Gửi thông báo cho merchant khi cấp/sửa",
      "autoLock": "Tự động khóa khi quá hạn (auto-lock overdue,)",
      "autoReset": "Tự động làm mới chu kỳ (auto-reset)",
      "reasonLabel": "Lý do",
      "confirm": {
        "edit": "Lưu thay đổi",
        "new": "Cấp hạn mức"
      },
      "submitting": "Đang lưu…"
    }
  },
  "edit": {
    "missingId": "Thiếu mã merchant trong đường dẫn.",
    "noPermission": "Bạn không có quyền chỉnh sửa merchant.",
    "loading": "Đang tải merchant để chỉnh sửa…",
    "loadError": "Không tải được merchant: {{message}}",
    "header": {
      "title": "Chỉnh sửa hồ sơ merchant",
      "subtitle": "Đang chỉnh sửa {{name}} · thay đổi được ghi vào nhật ký kiểm toán của merchant (MERCHANT_PROFILE_UPDATED)."
    },
    "savedToast": "Đã lưu · {{time}}",
    "fields": {
      "businessName": "Tên doanh nghiệp",
      "phone": "Số điện thoại",
      "taxId": "Mã số thuế",
      "street": "Địa chỉ (đường/phố)",
      "city": "Thành phố",
      "region": "Tỉnh/Bang",
      "postalCode": "Mã bưu chính",
      "country": "Quốc gia (ISO-3166 alpha-2)",
      "contractLegalEntity": "Pháp nhân ký hợp đồng"
    },
    "addressLegend": "Địa chỉ doanh nghiệp (tùy chọn — xóa hết để gỡ bỏ)",
    "reasonLabel": "Lý do thay đổi (tùy chọn, tối đa 500 ký tự — lưu vào metadata kiểm toán)",
    "validation": {
      "businessNameMin": "Tên doanh nghiệp phải có ít nhất 2 ký tự.",
      "phoneFormat": "Số điện thoại phải theo định dạng E.164 (ví dụ +14155551234) hoặc để trống.",
      "fixHighlighted": "Vui lòng sửa các trường được đánh dấu rồi thử lại.",
      "unknownError": "Lỗi không xác định"
    },
    "dirtyCount_one": "{{count}} trường đã thay đổi",
    "dirtyCount_other": "{{count}} trường đã thay đổi",
    "noChanges": "Không có thay đổi nào",
    "confirmDiscard": "Các thay đổi chưa lưu sẽ bị mất. Vẫn hủy?",
    "cancel": "Hủy",
    "save": "Lưu thay đổi",
    "saving": "Đang lưu…",
    "contractEntity": {
      "loading": "Đang tải…",
      "systemDefault": "Pháp nhân mặc định của hệ thống",
      "defaultTag": "{{name}} (mặc định)",
      "unknownEntity": "Pháp nhân không xác định ({{id}})",
      "hint": "Invoice, receipt và payment request sẽ phát hành từ pháp nhân này. Giữ mặc định hệ thống trừ khi merchant có hợp đồng riêng."
    }
  }
}
